import ForgotPasswordStart from '../../../auth/components/forgot-password/ForgotPasswordStart';

export default function ForgotPasswordStartPage() {
    return <ForgotPasswordStart />;
}
